export const last = (arr) => arr[arr.length - 1];
//# sourceMappingURL=last.js.map